import React from 'react';
import { Reviews } from '../../../components/BusinessesList';
import './styles.css';

const FeatureReviews = ({ reviews, title }) => {
  return (
    <div className="Landing__FeatureReviews__root">
      <h2 className="Landing__FeatureReviews__title">{title}</h2>
      <div className="Landing__FeatureReviews__content">
        <Reviews data={reviews} />
      </div>
    </div>
  );
};

export default FeatureReviews;
